// extracted by mini-css-extract-plugin
module.exports = {"Container":"IndexRoute_Container__WN4cF","Title":"IndexRoute_Title__1LPWV","Cards":"IndexRoute_Cards__I9vfo","ButtonContainer":"IndexRoute_ButtonContainer__2pOMv"};